import * as types from './types'

export default {
  // Guarda a resposta inteira ({ total, truncated, can_review, operations }), não só a lista:
  // `truncated` diz à faixa se o número que ela mostra é o total ou o teto, e `can_review` é o
  // que impede a tela de oferecer "Marcar como lido" a quem tomaria 403 — e 403 desloga.
  [types.MUTATE_UNREAD_FINANCIAL_BATCHES]: (state, payload) => {
    state.unread = payload
  },
  // ⚠️ Slot SEPARADO do `unread`, de propósito. A manchete da faixa conta os NÃO LIDOS, e ela
  // continua correta enquanto o painel exibe "Todos". Com um slot só, a mesma resposta serviria
  // aos dois e a frase passaria a afirmar que operações já revisadas não foram lidas.
  [types.MUTATE_RECENT_FINANCIAL_BATCHES]: (state, payload) => {
    state.recent = { ...payload, loaded: true }
  },
  [types.MUTATE_FINANCIAL_BATCH_ACKNOWLEDGE_MODAL]: (state, payload) => {
    state.acknowledgeModal = { ...state.acknowledgeModal, ...payload }
  },
}
